import React, { createContext, useContext, useState, useEffect } from 'react';
import { isRunningInWTN } from '@/utils';

const SignUpContext = createContext<any>(undefined);

export function SignUpProvider({ children }: any) {
	const [birthDate, setBirthDate] = useState({ day: '', month: '', year: '' });
	const [email, setEmail] = useState('');
	const [fullName, setFullName] = useState('');
	const [country, setCountry] = useState('');
	const [college, setCollege] = useState('');
	const [categories, setCategories] = useState([]);
	const [group, setGroup] = useState('');
	const [parentEmail, setParentEmail] = useState('');
	const [agree, setAgree] = useState(false);
	const [imageId, setImageId] = useState('');
	const [imgVariants, setImgVariants] = useState(null);
	const [error, setError] = useState('');
	const [preview, setPreview] = useState(null);
	const [isOtpFlow, setIsOtpFlow] = useState(false);
	const [isWTN, setIsWTN] = useState(false);
	const [isAvatarUploading, setIsAvatarUploading] = useState(false);
	const [isParentConsentSubmitting, setIsParentConsentSubmitting] = useState(false);

	useEffect(() => {
		let isMounted = true;
		let attempts = 0;
		let timeoutId: ReturnType<typeof setTimeout> | undefined;

		const detectWTN = async () => {
			const detected = await isRunningInWTN();
			if (!isMounted) return;

			setIsWTN(detected);

			if (!detected && attempts < 10) {
				attempts += 1;
				timeoutId = setTimeout(detectWTN, 300);
			}
		};

		detectWTN();

		return () => {
			isMounted = false;
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, []);

	const resetSignUp = () => {
		setBirthDate({ day: '', month: '', year: '' });
		setEmail('');
		setFullName('');
		setCountry('');
		setCollege('');
		setCategories([]);
		setGroup('');
		setParentEmail('');
		setAgree(false);
		setImageId('');
		setImgVariants(null);
		setError('');
		setPreview(null);
		setIsOtpFlow(false);
		setIsAvatarUploading(false);
		setIsParentConsentSubmitting(false);
	};

	return (
		<SignUpContext.Provider
			value={{
				birthDate,
				setBirthDate,
				email,
				setEmail,
				fullName,
				setFullName,
				country,
				setCountry,
				college,
				setCollege,
				categories,
				setCategories,
				group,
				setGroup,
				parentEmail,
				setParentEmail,
				agree,
				setAgree,
				imageId,
				setImageId,
				imgVariants,
				setImgVariants,
				error,
				setError,
				preview,
				setPreview,
				isOtpFlow,
				setIsOtpFlow,
				isWTN,
				setIsWTN,
				isAvatarUploading,
				setIsAvatarUploading,
				isParentConsentSubmitting,
				setIsParentConsentSubmitting,
				resetSignUp,
			}}
		>
			{children}
		</SignUpContext.Provider>
	);
}

export const useSignUp = () => {
	const ctx = useContext(SignUpContext);
	if (!ctx) throw new Error('useSignUp must be inside SignUpProvider');
	return ctx;
};
